import { useRegisterSW } from "virtual:pwa-register/react"

export function ReloadPrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, r) {
      r &&
        setInterval(
          () => {
            r.update()
          },
          5 * 60 * 1000
        )
    },
    onOfflineReady() {
      console.log("Service Worker: app ready to work offline")
    },
  })

  const close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  if (!offlineReady && !needRefresh) {
    return null
  }

  return (
    <div className="fixed right-4 bottom-4 z-50 max-w-sm rounded-lg border bg-card p-4 shadow-lg">
      <p className="mb-3 text-card-foreground text-sm">
        {offlineReady ? "App ready to work offline" : "New content available, reload to update."}
      </p>
      <div className="flex gap-2">
        {needRefresh && (
          <button
            type="button"
            className="rounded bg-primary px-3 py-1.5 text-primary-foreground text-sm hover:bg-primary/90"
            onClick={() => updateServiceWorker()}
          >
            Reload
          </button>
        )}
        <button
          type="button"
          className="rounded bg-secondary px-3 py-1.5 text-secondary-foreground text-sm hover:bg-secondary/90"
          onClick={close}
        >
          Close
        </button>
      </div>
    </div>
  )
}
